import React from 'react'

const Mt6 = () => {
    return (
        <div className='container'>
            <h1>Check mirror in n-ary tree</h1>
            <div class="text">
    <p>Given two n-ary trees, the task is to check if they are the mirror of each other or not. Print “Yes” if they are
        the mirror of each other else “No”.</p>
    <p><strong>Examples:&nbsp;</strong></p>
    <pre className='containers'>{`Input : Node = 3, Edges = 2
    Edge 1 of first N-ary: 1 2
    Edge 2 of first N-ary: 1 3
    Edge 1 of second N-ary: 1 3
    Edge 2 of second N-ary: 1 2
    Output : Yes`}</pre>
   <pre className='containers'>{`Input : Node = 3, Edges = 2
    Edge 1 of first N-ary: 1 2 
    Edge 2 of first N-ary: 1 3
    Edge 1 of second N-ary: 1 2
    Edge 2 of second N-ary: 1 3
    Output : No`}</pre>
    <p><strong>Approach &nbsp;: (Using Hashing)</strong></p>
    <p>The idea is to use an <strong>unordered map of stacks</strong> to check if given N-ary tree are mirror of each
        other or not.&nbsp;<br/>Let the first n-ary tree be t1 and the second n-ary tree is t2. For each node in t1, push
        its connected node in their corresponding stack in the map. Now, for each node in t2, their connected node match
        with the top of the stack, then pop elements from the stack. &nbsp;</p><br/>
    <div id="AP_G4GR_5"></div>
  
    <p>Otherwise, if the node does not match with the top of the stack then it means two trees are not mirror of each
        other.&nbsp;<br/>Now, for each corresponding node do the following:&nbsp;&nbsp;</p>
    <pre className='containers'>  1. Iterate over map of stack <br />
          Push all connected nodes of each node of first tree in map of  stack. <br />
     <br />
      2. Again iterate over map for each node of second tree <br />
         <strong> For example :  </strong>    <br />
     <br />
          Let us take one node X of second tree  <br />
           <br />
          For this node X , check in map which stack is used <br />
     <br />
          a = Top of that stack for node X present in second tree; <br />
          b = Connected node of X in second tree <br />
          if (a != b) <br />
               return false; <br />
          pop node X from stack.</pre> <br />
   
</div>
             <div class="tabs">
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
 
    
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program to check if two n-ary trees are</code>
    </div>
    <div class="line number2 index1 alt1"><code class="comments">// mirror.</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">// Function to check given two trees are mirror</code>
    </div>
    <div class="line number7 index6 alt2"><code class="comments">// of each other or not</code></div>
    <div class="line number8 index7 alt1"><code class="color1 bold">int</code> <code
            class="plain">checkMirrorTree(</code><code class="color1 bold">int</code> <code
            class="plain">M, </code><code class="color1 bold">int</code> <code class="plain">N, </code><code
            class="color1 bold">int</code> <code class="plain">u1[ ],</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">v1[ ] , </code><code class="color1 bold">int</code> <code
            class="plain">u2[], </code><code class="color1 bold">int</code> <code class="plain">v2[])</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Map to store nodes of the tree</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">unordered_map&lt;</code><code class="color1 bold">int</code> <code
            class="plain">, stack&lt;</code><code class="color1 bold">int</code><code class="plain">&gt;&gt;mp;</code>
    </div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Traverse first tree nodes</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 0 ; i &lt; N ; i++ )</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mp[u1[i]].push(v1[i]);</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Traverse second tree nodes</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 0 ; i &lt; N ; i++)</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code><code class="plain">(mp[u2[i]].top() != v2[i])</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mp[u2[i]].pop();</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">1;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code class="comments">// Driver code</code></div>
    <div class="line number32 index31 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number33 index32 alt2"><code class="plain">&#123;</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">M = 7, N = 6;</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">//Tree 1</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">u1[] = &#123; 1, 1, 1, 10, 10, 10 &#125;;</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">v1[] = &#123; 10, 7, 3, 4, 5, 6 &#125;;</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">//Tree 2</code></div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">u2[] = &#123; 1, 1, 1, 10, 10, 10 &#125;;</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">v2[] = &#123; 3, 7, 10, 6, 5, 4 &#125;;</code></div>
    <div class="line number43 index42 alt2">&nbsp;</div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code><code class="plain">(checkMirrorTree(M, N, u1, v1, u2, v2))</code></div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout&lt;&lt;</code><code class="string">"Yes"</code><code class="plain">;</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout&lt;&lt;</code><code class="string">"No"</code><code class="plain">;</code></div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number50 index49 alt1"><code class="plain">&#125;</code></div>
</div>
       </div>
    </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
        </div>
    )
}

export default Mt6
